export const appTheme = {
  classes: {
    root: 'app-root',
    page: 'app-page',
    container: 'app-container',
    title: 'app-title',
    intro: 'app-intro',
    surface: 'app-surface',
    reveal: 'app-reveal',
    fab: 'app-fab',
    toast: 'app-toast',
    mobileTab: 'app-mobile-tab',
  },
} as const

export type AppTheme = typeof appTheme
export * from "./ThemeProvider"
export * from "./useTheme"
